const mutation = {
  SET_WALLET_LIST(state, list) {
    const result = (state.page > 1) ? state.list.concat(list) : list;
    state.list = result;
    if (list.length) {
      state.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  SET_WALLET_LIST_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_WALLET_TRANSPORTER_LIST_LOADING(state, status) {
    state.isTransporterListLoading = status;
  },

  SET_WALLET_TRANSPORTER_LIST(state, list) {
    const result = (state.page > 1) ? state.transporterWallet.concat(list) : list;
    state.transporterWallet = result;
    if (list.length) {
      state.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  SET_WALLET_USED(state, ids) {
    const walletIdMap = state.transporterWallet.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    ids.forEach((element) => {
      if (walletIdMap[element].status) {
        walletIdMap[element].status = 2;
      }
    });
  },

  SET_PAGE(state, data) {
    state.page = data;
  },

  setDateRange(state, dates) {
    state.date_range = dates;
  },

  initData(state) {
    state.page = 1;
    state.hasEmpty = false;
    state.list = [];
    state.transporterWallet = [];
  },

};

export default mutation;
